import { render, staticRenderFns } from "./CardTotals.vue?vue&type=template&id=7c70624e&scoped=true"
import script from "./CardTotals.vue?vue&type=script&lang=js"
export * from "./CardTotals.vue?vue&type=script&lang=js"
import style0 from "./CardTotals.vue?vue&type=style&index=0&id=7c70624e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70624e",
  null
  
)

export default component.exports